import { Action } from "./actions";
import * as types from "./actions.types";
import { IAppPropsStore } from "./types";

const initialState: IAppPropsStore = {
  reCaptchaSiteKey: "",
  voiceGainServerUrl: "",
  voiceGainApplicationApiUrlPath: "",
  voiceGainAuthSvcApiUrlPath: "",
  ssoClientUrl: ""
};

const appPropsReducer = (
  state: IAppPropsStore = initialState,
  action: Action
): IAppPropsStore => {
  switch (action.type) {
    case types.SET_APP_PROPS:
      return {
        ...state,
        ...action.appProps
      };
    default:
      return state;
  }
};

export default appPropsReducer;
